var map = {
	"./bg/strings.json": 1802,
	"./cs/strings.json": 1803,
	"./da/strings.json": 1804,
	"./de/strings.json": 1805,
	"./el/strings.json": 1806,
	"./es-ES/strings.json": 1807,
	"./es-LA/strings.json": 1808,
	"./et/strings.json": 1809,
	"./fi/strings.json": 1810,
	"./fr-CA/strings.json": 1811,
	"./fr/strings.json": 1812,
	"./it/strings.json": 1813,
	"./lt/strings.json": 1814,
	"./lv/strings.json": 1815,
	"./nl/strings.json": 1816,
	"./no/strings.json": 1817,
	"./pl/strings.json": 1818,
	"./pseudo/strings.json": 1819,
	"./pt/strings.json": 1820,
	"./ro/strings.json": 1821,
	"./sk/strings.json": 1822,
	"./sl/strings.json": 1823,
	"./sv/strings.json": 1824,
	"./zh-CN/strings.json": 1825,
	"./zh-TW/strings.json": 1826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1801;